<div class="user-control-container" [hidden]="isHidden">
    <ng-template #userControl></ng-template>
</div>
